module.exports = __webpack_public_path__ + "f163721e679e3cea541248a59081f840.svg";